import { Label, FormFeedback } from "reactstrap";
import InputField from "components/Common/InputField";
import DuplicateEntryWarning from "./DuplicateEntryWarning/DuplicateEntryWarning";

const ChassisNumberField = ({
  formik,
  optionLoading = false,
  isLoading = false,
  verifyHandler = {},
}) => {
  
  const { isValidChassis, checking, verifyChassis } = verifyHandler

  return (
    <>
      <Label htmlFor="chassis_number">
        Chassis Number{" "}
        {checking && <small className="text-success">Checking...</small>}
      </Label>
      <InputField
        type="text"
        name="chassis_number"
        value={formik.values.chassis_number}
        disabled={!formik.values.vs_chassis_code_id}
        onChange={formik.handleChange}
        onBlur={verifyChassis}
        loading={optionLoading || isLoading}
        invalid={
          formik.touched.chassis_number && !!formik.errors.chassis_number
        }
        valid={
          isValidChassis &&
          !!formik.values.chassis_number &&
          !!formik.values.vs_chassis_code_id
        }
      />
      {formik.touched.chassis_number && formik.errors.chassis_number && (
        <FormFeedback>{formik.errors.chassis_number}</FormFeedback>
      )}

      {formik.touched.chassis_number && formik.errors.chassis_number && (
        <DuplicateEntryWarning
          show={true}
          onClose={() => console.log("Warning closed")}
          message={`${formik.errors.chassis_number} Please try another.`}
        />
      )}
    </>
  )
}

export default ChassisNumberField
